<template>
    <div>
        <div v-if="extra.old">
            <span class="timeline-key">Issued At </span>: {{extra.issued_at}}<br>
            <span class="timeline-key">Issued By </span>: {{extra.issued_by.name}}<br>
            <span class="timeline-key">Issued Office </span>: {{extra.issued_by.office}}<br>
            <div v-if="extra.issued_remarks"> <span class="timeline-key">Remarks </span>: {{extra.issued_remarks}}</div>
            <span class="timeline-key">Verified Date </span>: {{extra.verified_date}}<br>
            <span class="timeline-key">Verified By </span>: {{verified_by.verified_name}}<br>

        </div>
        <div v-else>
<!--          {{extra}}-->
<!--            <span class="timeline-key">Office </span>: {{extra.office}}<br>-->
<!--            <span class="timeline-key">Approved By </span>: {{user.name}}<br>-->
            <div v-if="extra.remarks && extra.remarks!=='undefined'"> <span class="timeline-key">Remarks </span> : {{extra.remarks}} <br></div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "Approved",
        props: ['extra', 'days', 'user'],
        computed: {
            verified_by() {
                let verified_name = this.extra.verified_by.split(',');
                if (verified_name.length === 3) {
                    verified_name = verified_name[0].split(':')[1].replace("'","").replace("'","");
                }else{
                    verified_name =''
                }
                return {
                    verified_name
                };
            }
        },
        mounted() {
            // console.log(this.extra);
        }
    }
</script>
